import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bmm_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('bmm_token');
      localStorage.removeItem('bmm_user');
      if (!window.location.pathname.includes('/admin')) {
        window.location.href = '/';
      } else {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const authAPI = {
  requestOTP: (phone) => api.post('/auth/request-otp', { phone }),
  verifyOTP: (phone, otp, purpose = 'login') => api.post('/auth/verify-otp', { phone, otp, purpose }),
  requestSignatureOTP: (phone) => api.post('/auth/request-signature-otp', { phone }),
  verifySignatureOTP: (phone, otp) => api.post('/auth/verify-signature-otp', { phone, otp, purpose: 'signature' }),
};

export const gstAPI = {
  verify: (gstin) => api.get(`/gst/verify/${gstin}`),
};

export const venueAPI = {
  create: (data) => api.post('/venues', data),
  getMyVenue: () => api.get('/venues/me'),
  submit: () => api.put('/venues/submit'),
  execute: () => api.put('/venues/execute'),
};

export const templateAPI = {
  get: () => api.get('/template'),
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/template/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const adminAPI = {
  dashboard: () => api.get('/admin/dashboard'),
  venues: (params) => api.get('/admin/venues', { params }),
  getVenue: (id) => api.get(`/admin/venues/${id}`),
  deleteVenue: (id) => api.delete(`/admin/venues/${id}`),
  updateTemplate: (content) => api.post('/admin/template', { content }),
  createSubAdmin: (data) => api.post('/admin/subadmin', data),
  listSubAdmins: () => api.get('/admin/subadmins'),
  deleteSubAdmin: (id) => api.delete(`/admin/subadmin/${id}`),
  clearData: () => api.delete('/admin/clear-data'),
};
